module.exports = __webpack_public_path__ + "static/media/lachlan-gowen-jrMsv-0o0bw-unsplash.d2ca415a.jpg";